export const ACTIVITY_ORIGIN_OPTIONS = Object.freeze([
  { key: "all", label: "Toutes", color: "#295d86" },
  { key: "team", label: "Équipe", color: "#2f9d62" },
  { key: "elsa", label: "Interventions ELSA", color: "#b45309" },
]);

export const getActivitySourceLabel = (activity) =>
  activity?.actorKind === "elsa_support" ? "Intervention ELSA" : "";

export const getActivityActorOptionLabel = (actor) => {
  const name = String(actor?.name || "").trim();
  return actor?.actorKind === "elsa_support"
    ? `${name} — Intervention ELSA`
    : name;
};
